import { z } from "zod";

import {
  ctaBannerSectionSchema,
  heroSectionSchema,
  pageSeoSchema,
  videoSectionSchema,
} from "@/content/schemas";
import { siteConfig } from "@/content/site";
import { validateContent } from "@/content/validateContent";

const youtubePageSchema = z.object({
  seo: pageSeoSchema,
  hero: heroSectionSchema,
  videoSection: videoSectionSchema,
  finalCta: ctaBannerSectionSchema,
});

export const youtubePageContent = validateContent("youtubePage", youtubePageSchema, {
  seo: {
    title: "YouTube | Tech Savvy Starts Here",
    description: "Watch practical AI and digital skills videos from Tech Savvy Starts Here.",
    canonicalPath: "/youtube",
    socialImage: "/social-card.svg",
  },
  hero: {
    eyebrow: "YouTube",
    title: "Watch Practical AI and",
    accent: "Digital Skills Lessons",
    description:
      "Explore beginner-friendly videos that break down AI, digital tools, and practical tech topics in a clear and approachable way.",
    primaryCta: {
      label: "Watch on YouTube",
      href: siteConfig.youtubeUrl,
      external: true,
    },
  },
  videoSection: {
    title: "Start with the latest practical lessons",
    description:
      "Watch the featured video, check out our free AI for beginners course, and visit the YouTube channel for the full library.",
    featured: {
      title: "Latest video",
      embedUrl: siteConfig.youtubeFeaturedEmbedUrl,
      placeholderLabel: "Latest video",
    },
    playlist: {
      title: "Playlist",
      embedUrl: siteConfig.youtubePlaylistEmbedUrl,
      placeholderLabel: "Playlist",
    },
    primaryCta: {
      label: "Visit the Channel",
      href: siteConfig.youtubeUrl,
      external: true,
    },
  },
  finalCta: {
    title: "Keep learning beyond the videos",
    description: "Subscribe to the newsletter for practical takeaways, beginner-friendly guidance, and clear next steps.",
    primaryCta: {
      label: "Subscribe to the Newsletter",
      href: "/newsletter",
      external: false,
    },
    tone: "light",
  },
});
